import ImageCompare from "image-compare-viewer";
import Swiper from "swiper/bundle";
import { Fancybox } from "@fancyapps/ui";

export default class MetalookPage {
  constructor(dom) {
    this.dom = dom;
    window.addEventListener("resize", () => this.resize());
  }
  init() {
    this.initImageComparison();
    this.initSlider();
    this.initFancyBox();
  }

  initImageComparison() {
    let imageCompareDOM = this.dom.querySelector("#image-compare");
    if (imageCompareDOM) {
      const imgBefore = imageCompareDOM.querySelector("img[data-label-before]");
      const imgAfter = imageCompareDOM.querySelector("img[data-label-after]");

      let labelBefore = "before";
      let labelAfter = "after";
      if (imgBefore) {
        labelBefore = imgBefore.getAttribute("data-label-before");
      }
      if (imgAfter) {
        labelAfter = imgAfter.getAttribute("data-label-after");
      }
      console.log(labelBefore, labelAfter);

      this.imageCompare = new ImageCompare(imageCompareDOM, {
        addCircle: true,
        showLabels: true,
        labelOptions: {
          before: labelBefore,
          after: labelAfter,
          onHover: false,
        },
      }).mount();
    }
  }

  initSlider() {
    const metalookSwiperDOM = this.dom.querySelector(".metalook-slider");
    if (metalookSwiperDOM != undefined) {
      let metalookSwiper = new Swiper(metalookSwiperDOM, {
        effect: "coverflow",
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: "auto",
        loop: true,
        coverflowEffect: {
          rotate: 0,
          stretch: 0,
          depth: 0,
          modifier: 1,
          scale: 0.9,
          slideShadows: false,
        },
        spaceBetween: 40,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    }
  }

  initFancyBox() {
    const metalookSwiperDOM = this.dom.querySelector(".metalook-slider");
    Fancybox.bind(metalookSwiperDOM, "[data-fancybox]", {
      wheel: "slide",
    });
  }

  resize() {}
}
